import { TFunction } from 'i18next';
import { FC, ReactNode } from 'react';

const HEADER_CELL_WIDTH = '7rem';
const HEADER_CELL_CLASS = `
  flex-none flex items-center justify-center 
  border-r border-gray-300 p-1 text-center leading-tight
`;

const HeaderCell: FC<{ children: ReactNode; width?: string }> = ({ children, width }) => (
  <div className={HEADER_CELL_CLASS} style={{ width: width ?? HEADER_CELL_WIDTH }}>
    {children}
  </div>
);

const HeaderGroup: FC<{ title: ReactNode; colSpan: number; children: ReactNode }> = ({
  title,
  colSpan,
  children,
}) => (
  <div
    className="flex flex-none flex-col border-r border-gray-300 text-center"
    style={{ width: `calc(${HEADER_CELL_WIDTH} * ${colSpan})` }}
  >
    <div className="border-b border-gray-300 bg-gray-200/50 py-1 font-semibold">{title}</div>
    <div className="flex h-full font-semibold">{children}</div>
  </div>
);

export const BusinessTableHeader = ({ t }: { t: TFunction }) => {
  return (
    <div className="flex min-h-[7.5rem] border-b border-gray-300 bg-gray-100 text-xs font-semibold">
      <HeaderCell>{t('wf.common.salesOffice')}</HeaderCell>
      <HeaderCell>{t('wf.common.section')}</HeaderCell>
      <HeaderCell>{t('wf.summary.seCount')}</HeaderCell>

      {/* Trapped Group */}
      <HeaderGroup title={t('wf.summary.trapped')} colSpan={3}>
        <HeaderCell>{t('wf.summary.occurrenceCount')}</HeaderCell>
        <HeaderCell>{t('wf.summary.completedCases')}</HeaderCell>
        <HeaderCell>{t('wf.summary.completionRate')}</HeaderCell>
      </HeaderGroup>

      {/* Current Status Group */}
      <HeaderGroup title={t('wf.summary.currentStatus')} colSpan={8}>
        <HeaderCell>{t('wf.summary.onCallFloodWind')}</HeaderCell>
        <HeaderCell>{t('wf.summary.onCall')}</HeaderCell>
        <HeaderCell>{t('wf.summary.powerOutage')}</HeaderCell>
        <HeaderCell>{t('wf.summary.otherAlarms')}</HeaderCell>
        <HeaderCell>{t('wf.summary.partReplacement')}</HeaderCell>
        <HeaderCell>{t('wf.summary.floodResponse')}</HeaderCell>
        <HeaderCell>{t('wf.summary.noEntry')}</HeaderCell>
        <HeaderCell>{t('wf.summary.restored')}</HeaderCell>
      </HeaderGroup>
    </div>
  );
};
